import { PureComponent } from 'react';
import Routes, { Router } from '../routes.mjs';
import { getMessages } from './i18n.mjs';

export default class EventPage extends PureComponent {
  static async getInitialProps({
    res, req, query: { eventsPath, slug, prefix },
  }) {
    const route = slug ? 'event' : 'events';
    const { eventsPath: actualEventsPath } = getMessages(
      req
        ? req.locale
        // eslint-disable-next-line no-underscore-dangle
        : window.__NEXT_DATA__.props.locale,
    );
    const queryWithoutPrefix = slug
      ? { eventsPath: actualEventsPath, slug }
      : { eventsPath: actualEventsPath };
    const query = prefix
      ? { ...queryWithoutPrefix, prefix } : queryWithoutPrefix;

    if (eventsPath !== actualEventsPath) {
      if (res) {
        res.writeHead(301, {
          Location: Routes.findAndGetUrls(
            route,
            query,
          ).urls.as,
        });
        res.end();
      } else {
        Router.pushRoute(route, query);
      }
    }

    return {};
  }
}
